import { Link } from 'gatsby';
import styled from 'styled-components';

export const AuthenticationStyle = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${(props) => props.theme.palette.background.default};
`;

export const Title = styled.h1`
  color: ${(props) => props.theme.palette.primary.main};
  font-size: 32px;
  font-weight: 500;
  line-height: 48px;
  text-align: center;
`;

export const Subtitle = styled.p`
  text-align: center;
`;

export const BottomText = styled.p`
  text-align: center;
  margin: 15px 0;
`;

export const BackLink = styled(Link)`
  display: flex;
  justify-content: center;
  padding: 20px 0 10px 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const HorizontalRule = styled.div<{ spacing?: string }>`
  padding-top: ${(props) => props.spacing ?? '20px'};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  margin-top: ${(props) => props.spacing ?? '20px'};
`;
